import logger from "../common/Logger"

class StorageService {
    static setSessionItem(key, obj) {
        if (!key) {
            throw Error("Key cannot be null")
        }
        if (typeof obj !== 'undefined') {
            sessionStorage.setItem(key, JSON.stringify(obj));
        }
    }

    static getSessionItem(key) {
        if (!key) {
            throw Error("Key cannot be null")
        }
        try {
            const obj = sessionStorage.getItem(key);
            return (obj ? JSON.parse(obj) : null);
        } catch (e) {
            logger.error("Error getting session item: '" + key + "': " + e.message);
            return null;
        }
    }

    static removeSessionItem(key) {
        if (!key) {
            throw Error("Key cannot be null")
        }
        sessionStorage.removeItem(key);
    }

    static hasSessionItem(key) {
        const obj = StorageService.getSessionItem(key);
        return typeof obj !== 'undefined' && obj != null;
    }
}

export default StorageService;



// WEBPACK FOOTER //
// ./src/modules/service/StorageService.js